import { verifyNow } from './server';
import { storageService } from 'js/services/storage.service';

export const getRedirectUrl = (type) => {
    const url = new window.URL(window.location.href);
    const isFromJumioPage = storageService.local.getItem('fromJumioPage');

    if (!isFromJumioPage) {
        storageService.local.setItem('fromJumioPage', true);
    }

    url.searchParams.set('jumioVerify', type);

    // restricted params
    [
        'transactionStatus',
        'customerInternalReference',
        'transactionReference',
        'errorCode'
    ].forEach(name => url.searchParams.delete(name));

    return url.toString();
};

export const handleRedirect = url => {
    const { handleJumioRedirect } = window.Playtech.API;

    if (typeof handleJumioRedirect === 'function') {
        handleJumioRedirect(url);

        return;
    }

    location.href = url;
};

export const handleVerifyClick = (documentType) => {
    const { handleJumioVerifyClick } = window.Playtech.API;

    if (typeof handleJumioVerifyClick === 'function') {
        handleJumioVerifyClick();

        return;
    }

    verifyNow({
        documentType,
        successUrl: getRedirectUrl('success'),
        errorUrl: getRedirectUrl('error')
    })
        .then(({ data: { redirectURL } }) => handleRedirect(redirectURL));
};
